<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" v-loading="loading" :model="formData" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="领用日期" prop="outboundDate">
              {{ formatDate(formData.outboundDate) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料名称" prop="materialName">
              {{ formData.materialName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产日期及批号" prop="productionDateBatchNo">
              {{ formData.productionDateBatchNo || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产厂家" prop="manufacturerName">
              {{ formData.manufacturerName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保质期" prop="shelfLife">
              {{ formData.shelfLife || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到货日期" prop="arrivalDate">
              {{ formatDate(formData.arrivalDate) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出库数量" prop="outboundQuantity">
              {{ formData.outboundQuantity === '' || formData.outboundQuantity == null ? '--' : formData.outboundQuantity }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出库原因" prop="outboundReason">
              {{ formData.outboundReason || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="领用人" prop="receiverUserName">
              {{ formData.receiverUserName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              {{ formData.remark || '--' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button v-if="loadFailed" @click="loadDetails" class="global-button">重新加载</el-button>
          <el-button @click="$router.back()" class="global-button">返回</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'MaterialOutboundDetail',
  data() {
    return {
      loading: false,
      loadFailed: false,
      formData: {
        outboundId: '', // 原辅料出库ID
        outboundDate: '', // 领用日期
        materialName: '', // 物料名称
        productionDateBatchNo: '', // 生产日期及批号
        manufacturerName: '', // 生产厂家
        shelfLife: '', // 保质期
        arrivalDate: '', // 到货日期
        outboundQuantity: '', // 出库数量
        outboundReason: '', // 出库原因
        receiverUserName: '', // 领用人
        remark: '' // 备注
      }
    }
  },
  computed: {
    outboundId() {
      return this.$route.query.outboundId
    }
  },
  created() {
    this.loadDetails()
  },
  methods: {
    formatDate(value, format = 'YYYY-MM-DD') {
      return value ? dayjs(value).format(format) : '--'
    },
    loadDetails() {
      if (!this.outboundId) {
        this.$message.warning('缺少记录ID')
        return
      }
      this.loading = true
      this.loadFailed = false
      return this.$axios.get(this.$apis.prodManage.selectScMaterialOutboundById, {
        params: { outboundId: this.outboundId }
      }).then(res => {
        this.formData = res
      }).catch(() => {
        this.loadFailed = true
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.form {
  word-break: break-all;
}
</style>
